import classNames from "classnames";
import { Card } from "~/features/configurator/Linear/components/Card";
import { type FC } from "react";
import { useIsMinDesktopSize } from "../hooks/useMediaQuery";

type Props = JSX.IntrinsicElements["div"] & {
  innerClassName?: string;
};

/**
 * Card to use for search boxes on various pages
 * @param className
 * @param rest
 * @constructor
 */
export const SearchCard: FC<Props> = ({ className, ...rest }) => {
  return <Card disableHover={true} className={classNames("p-30 mb-30", className)} {...rest} />;
};

export const MobileFriendlySearchCard = ({ className, ...rest }: JSX.IntrinsicElements["div"]) => {
  const isDesktop = useIsMinDesktopSize();

  const cls = classNames("scha__search-card", className, isDesktop && "scha__lc__card scha__lc__card--rounded");
  return <div className={cls} {...rest} />;
};
